import Logo, { LogoNameType } from "../Logo";
import { TextCombination } from "../TextCombination";

export type StatTileProps = {
  logo: LogoNameType;
  metric: string;
  description: string;
};

export const StatTile = ({ logo, metric, description }: StatTileProps) => (
  <div className="size-full flex flex-col justify-between">
    <div className="w-10 h-6 flex items-center">
      <Logo type={logo} isFullColor />
    </div>
    <TextCombination
      type="h3p2"
      headingLevel="h3"
      className="text-secondary"
      title={metric}
      description={description}
      align="left"
    />
  </div>
);
